import axios from 'axios';

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
    },
});

// Redirect to login page on 401 response
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response.status === 401) {
            navigateToLogin();
        }

        return Promise.reject(error);
    }
);

// Return response.data.data for success responses
apiClient.interceptors.response.use(
    (response) => response.data.data,
    (error) => Promise.reject(error)
);

const navigateToLogin = () => (window.location.href = '/');

export default apiClient;
